"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      style={{ top: "env(safe-area-inset-top, 0.5rem)" }}
      toastOptions={{
        style: {
          background:
            "color-mix(in oklab, var(--color-surface) 92%, transparent)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: "9999px",
          border: "1px solid var(--color-border)",
          color: "var(--color-text-primary)",
          padding: "10px 20px",
          fontSize: "0.875rem",
          fontWeight: "600",
          boxShadow: "0 25px 50px -12px rgba(15,23,42,0.24)",
        },
        duration: 6_000,
      }}
      className="toaster group pointer-events-auto"
      {...props}
    />
  );
};

export { Toaster };
